import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Column } from 'seagull';
import { outputToCost } from "../../../../../components/ServiceCreation/ServiceBuilder/ServiceBuilder.utils";
import ServicePriceEditorPopoverBundleContent from "../../../../../components/ServicePriceEditorPopover/ServicePriceEditorPopoverBundleContent/ServicePriceEditorPopoverBundleContent";
import ServicePriceEditorPopoverPricingContent from "../../../../../components/ServicePriceEditorPopover/ServicePriceEditorPopoverPricingContent/ServicePriceEditorPopoverPricingContent";
import { serviceModel } from "../../../../../models";
import { inputBillingDataToModel } from "../../../../../models/service-billing/setters";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ServiceRateModalContent = _ref => {
  let {
    service,
    draft,
    setDraft
  } = _ref;
  const {
    watch
  } = useFormContext();
  useEffect(() => {
    const subscription = watch(formValues => {
      const data = formValues;
      const cost = outputToCost({
        output: data,
        originalService: service
      });
      const billing = inputBillingDataToModel({
        billingForm: data,
        originalService: service
      });
      setDraft(draft.setService(service.id, s => {
        let updated = serviceModel.setCost(s, cost);
        updated = serviceModel.setBillingTrigger(updated, billing);
        return updated;
      }));
    });
    return () => subscription.unsubscribe();
  }, [watch, service, draft, setDraft]);
  return /*#__PURE__*/_jsxs(Column, {
    children: [/*#__PURE__*/_jsx(ServicePriceEditorPopoverPricingContent, {
      serviceOrigin: "draft"
    }), /*#__PURE__*/_jsx(ServicePriceEditorPopoverBundleContent, {})]
  });
};